import { Container, Theme, Typography, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { NextPage } from 'next';
import Image from 'next/image';
import SEO from '../components/common/SEO';
import StaticPageThemeProvider from '../components/providers/StaticPageThemeProvider';
import Waterfall from '../public/icons/about/waterfall.svg';
import Mountain from '../public/icons/about/mountain.svg';
import Landscape from '../public/icons/about/landscape.svg';
import AboutApp from '../public/images/about-app.png';

const About: NextPage = () => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  return (
    <StaticPageThemeProvider>
      <SEO title={'About'} />
      <Container>
        <Box sx={{ mx: '10vw', my: '150px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: { sm: '100vh' },
              }}
            >
              <Typography
                variant={'h1'}
                sx={{
                  fontSize: { xs: '24px', sm: '18px', md: '52px', lg: '52px' },
                  fontWeight: '800',
                  color: '#C7AA3E',
                }}
              >
                Indian Classical Music is sophisticated. Ragya makes it simple.
              </Typography>
              <Typography variant={'h2'} sx={{ fontSize: '18px', mt: 3 }}>
                The naturally evolved Raga framework can be trusted to curate
                music based on the choices nature makes for us over the course
                of the day. The ragas, which evoke clear emotional responses,
                naturally align with us, and hence, blend into our lives.
              </Typography>
              <Typography variant={'h2'} sx={{ fontSize: '18px', mt: 3 }}>
                There is something compelling, soothing, often haunting, almost
                primal about Indian classical music.
              </Typography>
              <Typography variant={'h2'} sx={{ fontSize: '18px', mt: 3 }}>
                Keen practitioners know that this enigmatic quality of Indian
                classical music stems from the fact that the notes in raga music
                are derived from nature itself – from the strings of notes that
                flow within the ‘still sound’ of the times of the day.
              </Typography>
            </Box>
            {/* {isDesktop && <Image src={Waterfall} alt='waterfall' />} */}
            {/* TODO fix sizing of waterfall */}
            {isDesktop && <Waterfall />}
          </Box>
          <Typography
            variant={'h1'}
            textAlign={'center'}
            color={'primary'}
            sx={{
              mt: 2,
              fontSize: { xs: '24px', sm: '18px', md: '52px', lg: '52px' },
              color: '#C7AA3E',
            }}
          >
            Bringing the art & the artistes to everyone
          </Typography>
          <Typography
            variant={'h3'}
            textAlign={'center'}
            color={'gray'}
            sx={{ mt: 2, m: '20px auto' }}
          >
            Ragya is not just an auto-curator of Indian classical music, it is
            also a mini encyclopedia of knowledge about each raga, artiste and
            composition.
          </Typography>
          <Image src={AboutApp} alt='about-app' />
          <Typography
            variant={'h3'}
            textAlign={'center'}
            color={'gray'}
            sx={{ mt: 2, m: '20px auto' }}
          >
            Ragya’s simple and intuitive interface allows eager listeners to
            dive-in as deep as they like into the exciting, ever-evolving world
            of Indian classical music, and at their own pace.
          </Typography>
          <Typography
            variant={'h3'}
            textAlign={'center'}
            color={'gray'}
            sx={{ mt: 2, m: '20px auto' }}
          >
            Overall, Ragya is a complete experience of Indian classical music
            for the digital age. Whether you are a novice listener or a
            connoiseur, a new artiste or a maestro, Ragya is for you.
          </Typography>
          {/* TODO slightly adjust sizing of mountain */}
          {/* <Image src={Mountain} alt='mountain-image' /> */}
          <Mountain />
          <Typography
            variant={'h1'}
            textAlign={'center'}
            color={'primary'}
            sx={{
              fontSize: { xs: '24px', sm: '18px', md: '52px', lg: '52px' },
              m: '20px auto',
              color: '#C7AA3E',
            }}
          >
            We intend to keep spreading Indian classical music. Join us if you’d
            like to, too.
          </Typography>
          <Typography
            variant={'h2'}
            textAlign={'center'}
            color={'gray'}
            sx={{ fontSize: '15px', m: '10px auto' }}
          >
            Ragya has been brought to life and continues to evolve through the
            commitment of a small team sharing a common vision
          </Typography>
        </Box>
        {/* <Image src={Landscape} alt='landscape-image' /> */}
        <Landscape />
      </Container>
    </StaticPageThemeProvider>
  );
};
export default About;
